import { oklchGradients } from '@cronos-app/chakra';
import type { GlobalProps } from '@emotion/react';
import { Global } from '@emotion/react';

const ConditionalChakraVarOverrides = () => {
  return <Global styles={styles} />;
};

const oklchGradientVariables = Object.fromEntries(
  Object.keys(oklchGradients).map((key) => [
    `--chakra-colors-gradients-${key}`,
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    oklchGradients[key as keyof typeof oklchGradients],
  ]),
);

const styles: GlobalProps['styles'] = {
  '@supports (background: linear-gradient(to right in oklch, #fff, #000))': {
    ':root': {
      ...oklchGradientVariables,
    },
  },
};

export default ConditionalChakraVarOverrides;
